jQuery(function($) {
	var $html = $('html').removeClass('no-js');

	$html.deepLinks();
	$('form input[id^="your-name_"]').attr('autocomplete', 'chrome-off');
	
	if(!$.supports.touch) {
		$('select[multiple]').multiselect();
	}

	// ADD ALL YOUR CUSTOM JS THINGS AFTER THIS LINE
	$('.navigation a').on({
		click: function() {
			// close menu through #hamburgerToggle checkbox
			$('#hamburgerToggle').prop('checked', false);
		}
	});

	/**
	 * add listeners for jumpnavigation between posts of history
	 */

	$('.article__nav').historyNav();

	$('.scroll-top-button').on({
		click: function() {
			$(document).scrollTop(0);
			return false;
		}
	})
});

